var exports = {
  "U": "xfd349460--f5121a--arrow",
  "i": "xfd349460--f5121a--animate",
};

module.exports = exports;
